import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,  
  Autocomplete,
  FormControl, FormHelperText,
  Select as SelectCity,
  Snackbar, SnackbarValue,
  CircularProgress,
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ChangeParametersDialog from "./changeParametersDialog";
import "ol/ol.css";
import "../../css/home.min.css";
import { Map, View } from "ol";
import DataService from "../../services/getData";
import MapUtils from "../../utils/mapUtils";
import { Vector as VectorSource } from "ol/source";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature.js";
import Polygon from "ol/geom/Polygon";
import GeoJSON from "ol/format/GeoJSON.js";
import noProjectImg from "../../assets/noProject.png";
import Utils from "../../utils/miscUtils";
import ResultsTable from "./resultsTable";
import { INDICATOR_MAP } from "../../utils/indicatorMap";
import StyledTooltip from "../../utils/styledToolTip";

export default function NewProject({ setShowNewProject }) {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const [selectedGrids, setSelectedGrids] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [cityDetails, setCityDetails] = useState(null);
  const [cities, setCities] = useState([]);
  const [map, setMap] = useState();
  const [gridFeatures, setGridFeatures] = useState([]);
  const [actions, setActions ] = useState([]);
  const [filterAreaDropdown, setFilterAreaDropdown] = useState([]);
  const [indicatorId, setIndicatorId] = useState("");
  const [actionAreaId, setActionAreaId] = useState("");
  // Amenity levels of the selected area ({sc_liv_sport_3: 3, ...}); {} when unknown, so nothing is disabled
  const [amenityLevels, setAmenityLevels] = useState({});
  const [listOfAreaActions, setListOfAreaActions] = useState([]);
  const [listOfImpacts, setListOfImpacts] = useState([]);
  const [otherId, setOtherId] = useState(null);
  const [impactLevelValue, setImpactLevelValue] = useState("");
  const [actionValue, setActionValue] = useState("");
  const [listOfSimulations, setListOfSimulations] = useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [newAdditionalInputs, setNewAdditionalInputs] = useState({});
  const [userInputs, setUserInputs] = useState({});
  const [advanceErrors, setAdvanceErrors] = useState([])
  const [simulationResults, setSimulationResults] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isError, setIsError] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false);
  const [SnackbarValue, setSnackbarValue] = useState({
      severity:"warning",
      message:""
    });
  const [openSelect, setOpenSelect] = useState(false);

  function extractGridValuesAndMaxScores(indicatorMap) {
    const results = [];

    indicatorMap.forEach(category => {
      // 1. Valores da própria categoria
      if (category.gridValue && category.maxScore && category.name) {
        results.push({
          name: category.name,
          gridValue: category.gridValue,
          maxScore: category.maxScore,
        });
      }

      // 2. Valores dos indicadores dentro da categoria
      category.indicators.forEach(ind => {
        if (ind.gridValue && ind.maxScore && ind.name) {
          results.push({
            name: ind.name,
            gridValue: ind.gridValue,
            maxScore: ind.maxScore,
          });
        }
      });
    });

    return results;
  }

  function construirIndicadoresFiltrados(indicadores, grids) {
    return indicadores.map((ind) => {
      const { gridValue, maxScore } = ind;

      // Se não houver grids, por segurança não desativamos
      if (!Array.isArray(grids) || grids.length === 0) {
        return { ...ind, disabled: false };
      }

      const allEqualToMax = grids.every((cell) => {
        const v = Number(cell.values_?.[gridValue]);
        if (!Number.isFinite(v)) return false; // se faltar valor, não é igual
        //return nearlyEqual(v, maxScore);
        return v == maxScore;
      });

      return { ...ind, disabled: allEqualToMax };
    });
  }

  const indicatorKeys = extractGridValuesAndMaxScores(INDICATOR_MAP);
  //console.log("Indicator Keys=", indicatorKeys);
  
  // util simples para normalizar strings
  const norm = (s) => (typeof s === "string" ? s.trim().toLowerCase() : "");

  // constrói uma lookup: {name(normalizado) -> disabled:boolean}
  const buildDisabledByName = (filtered) => {
    const map = new Map();
    (filtered || []).forEach((it) => {
      const key = norm(it?.name);
      if (!key) return;
      // se houver entradas duplicadas, basta uma estar true
      map.set(key, map.get(key) === true || it?.disabled === true);
    });
    return map;
  };

  const sortActionsAlphabetically = (items) =>
    [...(items || [])].sort((a, b) =>
      String(a?.actionSimulationName || "").localeCompare(
        String(b?.actionSimulationName || ""),
        "pt",
        { sensitivity: "base" }
      )
    );
  
  const handleMouseLeave = () => {
    //selectedGrids.forEach(grid => console.log(grid));
    //console.log("filterAreaDropdown=", filterAreaDropdown);
    const filtered = construirIndicadoresFiltrados(indicatorKeys, selectedGrids);
    //console.log("Filtered=", filtered);
    
    // 2) construir uma lookup por nome
    const disabledByName = buildDisabledByName(filtered);

    // 3) atualizar o estado baseando-te no valor atual
    setFilterAreaDropdown((prev) =>
      (prev || []).map((item) => {
        const isDisabled =
          disabledByName.get(norm(item?.indicatorName)) === true;
        return { ...item, disabled: isDisabled };
      })
    );
  };

  const handleClose = (event, reason) => {
    setOpenDialog(false);
  };

  const handleOpenDialog = () => setOpenDialog(true);

  // called when child dialog saves parameters
  const handleSaveParameters = ({ paramName, paramValue, paramEnabled }) => {
    console.info("Saved parameters:", { paramName, paramValue, paramEnabled });
    setOpenDialog(false);
  };

  const LoadCities = (locationMap) => {
    //const json = JSON.parse(localStorage.getItem("cityFeatures"))
    var res = {};
    res.data = [];
    res.data[0] = MapUtils.MapData(JSON.parse(localStorage.cities));
    var geoJsonFormat = new GeoJSON();
    var features = geoJsonFormat.readFeatures(res.data[0], {
      featureProjection: locationMap.getView().getProjection(),
    });

    var vectorSource = new VectorSource({
      format: new GeoJSON(),
      features: features,
      projection: "EPSG:4326",
    });

    var vectorLayer = new VectorLayer({
      source: vectorSource,
      style: MapUtils.Styles.cityStyle,
    });

    locationMap.addLayer(vectorLayer);
    locationMap.getView().fit(vectorSource.getExtent());
  };

  const getAllActions = async () =>{
    const dataTemp2 = await DataService.GetActions();
    setActions(dataTemp2.data);
    const uniqueIndicators = [
      ...new window.Map((dataTemp2.data || []).map((item) => [item.indicatorName, item])).values(),
    ];
    setFilterAreaDropdown(uniqueIndicators);
  };

  const addCityGrid = (id) => {
    console.warn("addCityGrid: city id vazio; não vou carregar overlay.", id);

    const map = mapInstance.current;
    let gridFeatures = [];
    DataService.GetCityGrid(id).then((cityGrid) => {
     
      let x = 0;
      cityGrid.data.forEach((grid) => {
        let gridFeature;
        gridFeature = MapUtils.getFeaturePolygon(grid.geom); //.neighborhoodGeom.shell.points.coordinates);
        gridFeature.setId("largeGrid-" + x++); //(grid.neighborhoodId);
        // ensure we always have an id for the grid (fallback to grid.i)
        const gridIdValue = grid.neighborhoodGridId != null ? grid.neighborhoodGridId : grid.i;
        gridFeature.set("neighborhoodGridId", gridIdValue);
        gridFeature.set("neighborhoodId", grid.i);
        gridFeature.set("name", grid.name || grid.displayName || grid.neighborhoodName);
        gridFeature.set("selected", false);
        gridFeature.set("retailFloorAreaRatioScore", grid.iid1);
        gridFeature.set("streetConnectivityScore", grid.iid2);
        gridFeature.set("populationDensityScore", grid.iid3);
        gridFeature.set("landUseMixScore", grid.iid4);
        gridFeature.set("walkabilityCyclabilityCombinedScore", grid.iid5);
        gridFeature.set("trafficSafetyScore", grid.iid7);
        gridFeature.set("accessibilityScore", grid.iid8);
        gridFeature.set("naturalAreaScore", grid.iid9);
        gridFeature.set("exposurePollutantScore", grid.iid10);
        gridFeature.set("livabilityCombinedScore", grid.iid11);
        gridFeature.set("generalScore", grid.iid12);
        //highest
        gridFeature.set("retailFloorAreaRatioHighest", grid.highestRetailRloorArea);
        gridFeature.set("streetConnectivityHighest", grid.highestStreetConnectivity);
        gridFeature.set("populationDensityHighest", grid.highestPopulationDensity);
        gridFeature.set("landUseMixHighest", grid.highestLandUseMix);
        gridFeature.set("walkabilityCyclabilityCombinedHighest", grid.highestWalkabilityCyclabilityCombined);
        gridFeature.set("trafficSafetyHighest", grid.highestTrafficSafety);
        gridFeature.set("accessibilityHighest", grid.highestAccessibility);
        gridFeature.set("naturalAreaHighest", grid.highestNaturalArea);
        gridFeature.set("exposurePollutantHighest", grid.highestExposurePollutant);
        gridFeature.set("livabilityCombinedHighest", grid.highestLivabilityCombined);

        //gridFeature.set("scores", MapUtils.SetScores(grid));
        gridFeature.setStyle(MapUtils.Styles.gridForLocationStep);
        gridFeatures.push(gridFeature);
      });
      
      // debug: log if any feature missing neighborhoodGridId (shouldn't happen after fallback)
      const missing = gridFeatures.filter((gf) => !gf || !gf.values_ || gf.values_.neighborhoodGridId == null);
      if (missing.length > 0) {
        console.warn('addCityGrid: some gridFeatures missing neighborhoodGridId (unexpected):', missing.length, missing.slice(0,3));
      } else if (gridFeatures.length > 0) {
        // log a sample for verification
        console.info('addCityGrid: grid feature values:', gridFeatures[0].values_);
      }
      setGridFeatures(gridFeatures);

      const gridSource = new VectorSource({ features: gridFeatures });

      const gridLayer = new VectorLayer({
        source: gridSource,
        minZoom: 8,
        opacity: 0.7,
      });
      if (map.getAllLayers()[3] !== undefined)
        map.removeLayer(map.getAllLayers()[3]);
      gridLayer.setZIndex(200);
      map.addLayer(gridLayer);
    });
  };

  const AddMapClick = (locationMap) => {
    
    locationMap.on("click", function (event) {
      console.log("map Click")
      localStorage.setItem("locationIsValid", false);
      localStorage.setItem("clickedCoordinates", "");
      localStorage.setItem("neighborhoodGridId", '[]');
      let hasSelectedFeature = false;

      this.forEachFeatureAtPixel(event.pixel, function (feature) {
        console.log("Feature=", feature);
        if (hasSelectedFeature) return;

        if (feature.values_.type != "Polygon") {
          const previousCityId = MapUtils.getCityIdByName(
            document.getElementById("simple-city-select").value
          );
          if (previousCityId !== "")
            locationMap
              .getAllLayers()[1]
              .getSource()
              .getFeatureById(previousCityId)
              .setStyle(MapUtils.Styles.cityStyle);
          setSelectedCity(feature.id_);
          localStorage.setItem("selectedCity", feature.id_);
          hasSelectedFeature = true;
          locationMap
            .getAllLayers()[1]
            .getSource()
            .getFeatureById(feature.id_)
            .setStyle(MapUtils.Styles.selectedCity);
          DataService.GetCity(feature.id_).then((city) => {
            console.log("City=", city.data.originalCityName);
            drawPolygonOnMap(city, locationMap);
            getAdditionInputs(city.data.regionName, city.data.countryName);
            addCityGrid(city.data.cityId);
            setCityDetails(city.data);
          });
        } else {
          if (feature.id_ && feature.id_.indexOf("Grid") > 0) {
            hasSelectedFeature = true;

            selectGridOnMap(feature, event);
          }
        }
      });
    });
  };
  
  const selectGridOnMap = (feature, event) => {

      if (!feature.values_.selected) {
        feature.setStyle(
          MapUtils.Styles.selectedNeighborhoodForLocationStep
        );
        feature.set("selected", true);
      } else {
        feature.setStyle(MapUtils.Styles.neighborhoodForLocationStep);
        feature.set("selected", false);
      }
      localStorage.setItem("locationIsValid", true);
      localStorage.setItem("ProjectIsValid", true);
      if(event){
        localStorage.setItem(
          "clickedCoordinates",
          JSON.stringify(event.coordinate)
        );
      }
      const neighborhoodGridIds = localStorage.getItem("neighborhoodGridId") !== null? 
        localStorage.getItem("neighborhoodGridId").split(",") : [] ;
      neighborhoodGridIds.push(feature.values_.neighborhoodGridId);
      localStorage.setItem(
        "neighborhoodGridId",
        JSON.stringify(neighborhoodGridIds)
      );
      localStorage.setItem(
        "neighborhoodId",
        feature.values_.neighborhoodId
      );
        // toggle by neighborhoodGridId (was using neighborhoodId incorrectly)
        toggleGridIds(feature.values_.neighborhoodGridId);
  }
  //Just in case
  const ResetStyleForFeatures = (features, style) => {
    features.map((feature) => {
      //fx = contextMap.getAllLayers()[1].getSource().getFeatures()[x];
      feature.setStyle(style); // styles.cityStyle);
      features._state = null;
    });
  };

  const drawCityGridOnMap = (cityGrid, map, selectdGrids = []) => {
    let gridFeature;
    let gridFeatures = [];
    const selectedIds = new Set(
      Array.isArray(selectedGrids)
        ? selectedGrids.map((grid) => String(grid.values_.neighborhoodGridId))
        : []
    );

    cityGrid.data.forEach((grid) => {
      gridFeature = MapUtils.getFeaturePolygon(grid.geom);
      const gridId = String(grid.neighborhoodGridId ?? grid.i);
      if (selectedIds.has(gridId)) {
        gridFeature.setStyle(MapUtils.Styles.selectedNeighborhood);
      }
      gridFeatures.push(gridFeature);
    });

    const gridLayer = new VectorLayer({
      source: new VectorSource({ features: gridFeatures }),
      //maxZoom: 15,
      minZoom: 8,
      opacity: 0.5,
    });
    gridLayer.setZIndex(2);
    map.addLayer(gridLayer);
  };

  // adiciona, ou remove feature do array selectedGrids (usa neighborhoodGridId)
  const toggleGridIds = (id) => {
    if (!id) return;
    setSelectedGrids((prev) => {
      const idStr = String(id);
      const exists = prev.find((f) => String(f.values_.neighborhoodGridId) === idStr);
      const allFeatures = mapInstance.current
        ? mapInstance.current.getAllLayers()[3].getSource().getFeatures()
        : [];
      if (exists) {
        // remove
        const newPrev = prev.filter((f) => String(f.values_.neighborhoodGridId) !== idStr);
        const feat = allFeatures.find((ft) => String(ft.values_.neighborhoodGridId) === idStr);
        if (feat) {
          feat.set("selected", false);
          feat.setStyle(MapUtils.Styles.gridForLocationStep);
        }
        return newPrev;
      } else {
        // add
        const feat = allFeatures.find((ft) => String(ft.values_.neighborhoodGridId) === idStr);
        if (feat) {
          feat.set("selected", true);
          feat.setStyle(MapUtils.Styles.selectedNeighborhoodForLocationStep);
          return [...prev, feat];
        }
        return prev;
      }
    });
  };

  const drawPolygonOnMap = (city, locationMap) => {
    const map = mapInstance.current;

    const coordinates = city.data.geom;
    var convertedCoordinates = [];
    coordinates.forEach((element) => {
      convertedCoordinates.push([element.x, element.y]);
    });

    const polygonFeature = new Feature({
      type: "Polygon",
      geometry: new Polygon([convertedCoordinates]).transform(
        "EPSG:4326",
        "EPSG:3857"
      ),
      name: city.data.originalCityName,
    });

    polygonFeature.setId(city.data.cityId);

    let source = new VectorSource({
      features: [polygonFeature],
      //features: new GeoJSON().readFeatures(polygonFeature),
    });

    DataService.GetCityGrid(city.data.cityId)
      .then((cityGrid) => {
        drawCityGridOnMap(cityGrid, mapInstance.current);
      })
      .catch((err) => {
        console.error("Erro na API ao ler a Grid:", err);
      });

    var layer = new VectorLayer({
      source: source,
      style: MapUtils.Styles.polygonStyle,
    });
    layer.setZIndex(1);

    // Remove Previous Layer with polygon
    if (map.getLayers().array_[3] !== undefined)
      map.removeLayer(map.getLayers().array_[3]);
    if (map.getLayers().array_[2] !== undefined)
      map.removeLayer(map.getLayers().array_[2]);
    map.addLayer(layer);
    //map.zoomToExtent(polygonFeature.geometry.getBounds());

    const extent = source.getExtent();
    map.getView().fit(extent);

    localStorage.setItem("locationIsValid", false);
    //setSelectedCity(city.id);
  };

  const handleChange = (event, newValue) => {
    const map = mapInstance.current;
    let cityId = event.target === undefined ? event : newValue?.cityId;
    console.log("handleChange City=", cityId);
    ResetStyleForFeatures(
      map.getAllLayers()[1].getSource().getFeatures(),
      MapUtils.Styles.cityStyle
    );
    if (cityId === undefined || cityId === "") {
      setSelectedCity("");
      if (map.getAllLayers()[2] !== undefined)
        map.removeLayer(map.getAllLayers()[2]);
      if (map.getAllLayers()[2] !== undefined)
        map.removeLayer(map.getAllLayers()[2]);
      const vectorSource = mapInstance.current
        .getLayers()
        .array_[1].getSource();
      map.getView().fit(vectorSource.getExtent());
      map.getView().setZoom(map.getView().getZoom() - 0.2);
      //setSelectedGrids([]);
      return;
    }
    setSelectedCity(cityId);
    setCityDetails(cities.find((city)=> city.cityId === cityId));
    localStorage.setItem("selectedCity", cityId);
    map
      .getAllLayers()[1]
      .getSource()
      .getFeatureById(cityId)
      .setStyle(MapUtils.Styles.selectedCity);
    // Fetch full city object first (drawPolygonOnMap expects a city object)
    DataService.GetCity(cityId)
      .then((city) => {
        drawPolygonOnMap(city, map);
        getAdditionInputs(city.data.regionName, city.data.countryName);
        addCityGrid(city.data.cityId);
      })
      .catch((err) => {
        console.error("Erro na API ao ler a City:", err);
      });
  };

  const handleClearAll = () => {
    const allCityFeatures = mapInstance.current
      .getAllLayers()[3]
      .getSource()
      .getFeatures();
    allCityFeatures.map((feature) => {
      feature.setStyle(MapUtils.Styles.gridForLocationStep);
      feature.set("selected", false);
    });
    setSelectedGrids([]);
  };

  const handleSelectAll = () => {
    const allCityFeatures = mapInstance.current
      .getAllLayers()[3]
      .getSource()
      .getFeatures();
    let selected = [];
    allCityFeatures.forEach((feature) => {
      feature.setStyle(MapUtils.Styles.selectedNeighborhoodForLocationStep);
      feature.set("selected", true);
      selected.push(feature);
    });
    console.log("All features selected");
    setSelectedGrids(selected);
  };

  // Amenity actions (see actions_calculus) and the grid column each one raises
  const AMENITY_ACTION_COLUMNS = {
    "c49003e2-f683-4d10-b2a3-31f0c64c1210": "sc_liv_school_3",
    "0b778975-f5ff-4e6a-b01c-b5b847294ba7": "sc_liv_childcare_3",
    "eba4d074-8a0e-4f35-90b5-672782969b9a": "sc_liv_library_3",
    "894eb7c5-978a-4a38-8d99-f0f9c7bebe1f": "sc_liv_sport_3",
    "767778ed-a543-434a-993d-cb0381224fea": "sc_liv_grocery_3",
    "a7b27923-c339-4fbe-b44e-d45ea3116ec6": "sc_liv_pharmacy_3",
    "0fd87436-02f4-4002-b5a3-62f56cfe2c5c": "sc_liv_museum_3",
    "d1b4874e-db28-4a08-99b2-92c1b58824d0": "sc_liv_hospital_3",
    "d7231193-8f40-47be-8368-bf861d8b0916": "sc_liv_cinetheatre_3",
  };
  const AMENITY_MAX_LEVEL = 3;

  // Current level of the amenity an action raises, or null if it isn't an amenity action / level unknown
  const amenityLevelOf = (actionId) => {
    const level = amenityLevels[AMENITY_ACTION_COLUMNS[actionId]];
    return level === undefined || level === null ? null : Number(level);
  };

  // An amenity action only raises the level up to the chosen value, so choosing a level the area
  // already has changes nothing (all results would be zero).
  const isNoOpAmenityLevel = (actionId, impactValue) => {
    const level = amenityLevelOf(actionId);
    return level !== null && Number(impactValue) <= level;
  };

  const loadAmenityLevels = (indicatorActionsList) => {
    setAmenityLevels({});
    const hasAmenityAction = indicatorActionsList.some((a) => AMENITY_ACTION_COLUMNS[a.actionSimulationId]);
    const gridIds = selectedGrids.map((grid) => grid.values_.neighborhoodGridId).filter(Boolean);
    if (!hasAmenityAction || gridIds.length === 0) return;
    DataService.GetAreaAmenityLevels(gridIds)
      .then((response) => setAmenityLevels(response?.data || {}))
      .catch((err) => console.log("Area amenity levels unavailable; not disabling actions.", err));
  };

  const handleAreaDropdown = (e) =>{
    const id = e.target.value;
    const clicked = document.querySelector(
      '[name="' + e.target.value +'"]'
    );

    const isDisabled = clicked?.closest(".menu-item-disabled") !== null;
    if (isDisabled) {
      setSnackbarValue({
        severity:'warning',
        message:"Not possible to select this indicator for the chosen area because it is already at the maximum score."
      });
      return; // prevent selection if disabled
    } 

    let temp = actions.filter(action => {return action.indicatorId === id});
    let other = temp.find(item => item.actionType == 'Other');
    //console.log("actions -> indicatorName=", actions)
    if(other){
      setOtherId(other.actionSimulationTypeId)
      setListOfAreaActions(
        sortActionsAlphabetically([
          ...temp,
          {
            actionSimulationId:other.actionSimulationTypeName,
            actionSimulationName: other.actionSimulationTypeName,
            actionSimulationDescription: other.actionSimulationDescription
          }
        ])
      )
    }else{
      setListOfAreaActions(sortActionsAlphabetically(temp))
    }
    setIndicatorId(id);
    setListOfImpacts([]);
    setImpactLevelValue("");
    setActionAreaId("");
    setActionValue(""); 
    loadAmenityLevels(temp);
  }

  useEffect(() => {
    console.log("listOfSimulations=", listOfSimulations);
  }, [listOfSimulations]);

  useEffect(() => {
    console.log("ListOfImpacts=", listOfImpacts);
    console.log("action areda ID=", actionAreaId);
    console.log("listOfAreaActions=", listOfAreaActions);
    console.log("listOfImpacts[0]?.type=", listOfImpacts[0]?.type);
  }, [listOfImpacts]);

  const selectedAction = listOfAreaActions?.find(
    (x) => x.actionSimulationId === actionAreaId
  );

  const handleIndicatorDropdown = (id) =>{
    if (amenityLevelOf(id) !== null && amenityLevelOf(id) >= AMENITY_MAX_LEVEL) {
      setSnackbarValue({
        severity:'warning',
        message:"Not possible to select this action because the selected area is already at the maximum level for this amenity."
      });
      return;
    }
    setActionAreaId(id);
    const temp = listOfAreaActions.find(action => action.actionSimulationId === id);
    console.log("Temp List=", temp);
    let list = [];
    if(temp.impactTypeName!='Binary'){
      list = [{name: temp.listItem1Name, impactDescription: temp.listItem1Description, impactValue:temp.listItem1Value, type: temp.impactTypeName},
        {name: temp.listItem2Name,impactDescription: temp.listItem2Description, impactValue:temp.listItem2Value, type: temp.impactTypeName},
        {name: temp.listItem3Name,impactDescription: temp.listItem3Description, impactValue:temp.listItem3Value, type: temp.impactTypeName}];
      console.log("List=", list);
      setListOfImpacts(list);
    } else { // if action is Binary then this value should be already defined.
      setActionValue(1);
      return;
    }
    // reset any previously entered action value when indicator changes
    setActionValue("");
  }

  const handleLevelDropdown = (value) =>{
    setActionValue(value);
   }

  const handleAddSimulationList = () =>{
    const areaAction = listOfAreaActions.find((action) => action.actionSimulationId === actionAreaId);
    if (typeof areaAction === "undefined") {
      setSnackbarValue({
        severity:'warning',
        message:"Need to add an action first."
      });
      return;
    }
    console.log("handle add action value=", actionValue, " areaAction=", areaAction);
    if (areaAction.impactTypeName == "Binary") setActionValue(1);
    const actionValueToUse = areaAction.impactTypeName == "Binary" ? 1 : actionValue;
    if (isNoOpAmenityLevel(actionAreaId, actionValueToUse)) {
      setSnackbarValue({
        severity:'warning',
        message:"The selected area already has this level for this amenity, so this action would not change any result."
      });
      return;
    }
    const canAddSimulation =
      actionValueToUse !== "" &&
      listOfSimulations.length < 5 &&
      listOfSimulations.findIndex((item) => item.indicatorId === indicatorId) === -1;

    if (canAddSimulation) {
      setListOfSimulations((prev) => [
        ...prev,
        {
          actionAreaId: actionAreaId,
          indicatorId: indicatorId,
          impactListType: areaAction?.impactTypeName || "",
          actionName:areaAction?.actionSimulationName || "",
          impact: actionValueToUse,
          impactListValue: actionValueToUse,
          impactLevelValue: actionValueToUse
        },
      ]);

      // Clear dropdown values and dependent options after adding an action.
      setIndicatorId("");
      setActionAreaId("");
      setListOfAreaActions([]);
      setListOfImpacts([]);
      setImpactLevelValue("");
      setActionValue("");
      setOpenSelect(false);
    }

    if (listOfSimulations.findIndex(item => item.indicatorId === indicatorId) !== -1) {
      setSnackbarValue({
          severity:'warning',
          message:"An action for this indicator has already been added."
        });
    }
  }
  
  const handleSimulation = () =>{
    setIsProcessing(true);
    let tempInputs = {... userInputs};
    handleActionsPopulation(tempInputs)
    populateAdditionalInputs(tempInputs)
    getData(tempInputs);
  }
  const handleActionsPopulation = (userInputs) =>{

    userInputs.userSelectedGrids = selectedGrids.map((grid) => grid.values_.neighborhoodGridId);
    userInputs.projectYear = new Date().getFullYear();
    userInputs.assessmentTime = 25; // TODO - make dynamic
    userInputs.typeOfSimulation = 0; // TODO - WALKING/ CYCLING/ COMBINED
    userInputs.action1Id = "";
    userInputs.action1ImpactValue = "";
    userInputs.action2Id = "";
    userInputs.action2ImpactValue = "";
    userInputs.action3Id = "";
    userInputs.action3ImpactValue = "";
    userInputs.action4Id = "";
    userInputs.action4ImpactValue = "";
    userInputs.action5Id = "";
    userInputs.action5ImpactValue = "";
    
    for (let i = 0; i < listOfSimulations.length; i += 1) {
      switch (i) {
        case 0:
          userInputs.action1Id = listOfSimulations[i].actionAreaId;
          userInputs.action1ImpactValue = Utils.ImpactConverter(listOfSimulations[i]);
          break;
        case 1:
          userInputs.action2Id = listOfSimulations[i].actionAreaId;
          userInputs.action2ImpactValue = Utils.ImpactConverter(listOfSimulations[i]);
          break;
        case 2:
          userInputs.action3Id = listOfSimulations[i].actionAreaId;
          userInputs.action3ImpactValue = Utils.ImpactConverter(listOfSimulations[i]);
          break;
        case 3:
          userInputs.action4Id = listOfSimulations[i].actionAreaId;
          userInputs.action4ImpactValue = Utils.ImpactConverter(listOfSimulations[i]);
          break;
        case 4:
          userInputs.action5Id = listOfSimulations[i].actionAreaId;
          userInputs.action5ImpactValue = Utils.ImpactConverter(listOfSimulations[i]);
          break;
        default:
          break;
      }
    }
  }

  const populateAdditionalInputs = (tempInputs) => {
    tempInputs.userCenterPointGeom = localStorage.getItem("clickedCoordinates")
    tempInputs.averageTripDurationPreproject = newAdditionalInputs.pre_project_conditions_walking.average_trip_duration;
    tempInputs.averageTripDurationPostproject = newAdditionalInputs.post_project_conditions_walking.average_trip_duration;
    tempInputs.averageTripSpeedPreproject = newAdditionalInputs.pre_project_conditions_walking.average_trip_speed;
    tempInputs.averageTripSpeedPostproject = newAdditionalInputs.post_project_conditions_walking.average_trip_speed;
    tempInputs.averageTripDistancePreproject = newAdditionalInputs.pre_project_conditions_walking.average_trip_distance;
    tempInputs.averageTripDistancePostproject = newAdditionalInputs.post_project_conditions_walking.average_trip_distance;
    tempInputs.cityModeShareWalkPercentage = newAdditionalInputs.city_mode_share.walk;
    tempInputs.cityModeShareBicyclePercentage = newAdditionalInputs.city_mode_share.bicycle;
    tempInputs.cityModeShareCarMotorcycleSharePercentage = newAdditionalInputs.city_mode_share.car_and_motor_cycle_share;
    tempInputs.cityModeShareCarMotorcycleSoloPercentage = newAdditionalInputs.city_mode_share.car_and_motor_cycle_solo;
    tempInputs.cityModeShareTaxiMinibuPercentage = newAdditionalInputs.city_mode_share.taxi_or_mini_bus;
    tempInputs.cityModeSharePublicTransportPercentage = newAdditionalInputs.city_mode_share.public_transport;
    tempInputs.cyclingMinApplicableAge = newAdditionalInputs.physical_benefits_params[0].applicable_age_min;
    tempInputs.cyclingMaxApplicableAge = newAdditionalInputs.physical_benefits_params[0].applicable_age_max;
    tempInputs.cyclingRelativeRisk = newAdditionalInputs.physical_benefits_params[0].relative_risk;
    tempInputs.cyclingReferenceVolume = newAdditionalInputs.physical_benefits_params[0].reference_volume;
    tempInputs.cyclingCapsPercentImprove = newAdditionalInputs.physical_benefits_params[0].caps_percentage;
    tempInputs.cyclingCapsMinPWeek = newAdditionalInputs.physical_benefits_params[0].caps_min_or_week;
    tempInputs.walkingMinApplicableAge = newAdditionalInputs.physical_benefits_params[1].applicable_age_min;
    tempInputs.walkingMaxApplicableAge = newAdditionalInputs.physical_benefits_params[1].applicable_age_max;
    tempInputs.walkingRelativeRisk = newAdditionalInputs.physical_benefits_params[1].relative_risk;
    tempInputs.walkingReferenceVolume = newAdditionalInputs.physical_benefits_params[1].reference_volume;
    tempInputs.walkingCapsPercentImprove = newAdditionalInputs.physical_benefits_params[1].caps_percentage;
    tempInputs.walkingCapsMinPWeek = newAdditionalInputs.physical_benefits_params[1].caps_min_or_week;
    //tempInputs.currency = selectedCurrency.id;
    tempInputs.valueLifeYear = newAdditionalInputs.economic_factor.value_of_statistical_life;
    tempInputs.valueStatisticalLife = newAdditionalInputs.economic_factor.value_of_life_year;
    tempInputs.discountRate = newAdditionalInputs.economic_factor.discount_rate;
    tempInputs.carMotorcycleRideShareJourneyLength = newAdditionalInputs.journey_length.car_and_motorcycle_share;
    tempInputs.projectCarMotorcycleRideSharePercentage = newAdditionalInputs.proportion_project_origin_modes.car_and_motorcycle_share;
    tempInputs.carMotorcycleSoloDriverJourneyLength = newAdditionalInputs.journey_length.car_and_motorcycle_solo;
    tempInputs.projectCarMotorcycleSoloDriverPercentage = newAdditionalInputs.proportion_project_origin_modes.car_and_motorcycle_share;
    tempInputs.projectTaxiMinibusPercentage = newAdditionalInputs.proportion_project_origin_modes.taxi_and_minibus;
    tempInputs.projectPublicTransportPercentage = newAdditionalInputs.proportion_project_origin_modes.public_transport;
    tempInputs.malePercentageCyclistsWalkers = newAdditionalInputs.cyclists_population_gender.male_percentage;
    tempInputs.femalePercentageCyclistsWalkers = newAdditionalInputs.cyclists_population_gender.female_percentage;
    tempInputs.projectBicyclePercentage = newAdditionalInputs.proportion_project_origin_modes.bicycle;
    tempInputs.projectWalkPercentage = newAdditionalInputs.proportion_project_origin_modes.walk;
    tempInputs.carMotorcycleRideShareJourneyLength = newAdditionalInputs.journey_length.car_and_motorcycle_share;
    tempInputs.carMotorcycleSoloDriverJourneyLength = newAdditionalInputs.journey_length.car_and_motorcycle_solo;
    tempInputs.taxiOrMinibusJourneyLength = newAdditionalInputs.journey_length.taxi_and_minibus;
    tempInputs.publicTransportJourneyLength = newAdditionalInputs.journey_length.public_transport;
    tempInputs.bicycleJourneyLength = newAdditionalInputs.journey_length.bicycle;
    tempInputs.walkJourneyLength = newAdditionalInputs.journey_length.walk;
    tempInputs.minimumAge = newAdditionalInputs.age_range_of_cyclists.min_age;
    tempInputs.maximumAge = newAdditionalInputs.age_range_of_cyclists.max_age;
    tempInputs.capex = newAdditionalInputs.project_costs_estimates.capex;
    tempInputs.opex = newAdditionalInputs.project_costs_estimates.opex;
    tempInputs.totalMinutesOfActivityPerYearPreproject = newAdditionalInputs.pre_project_conditions_walking.total_minutes_of_activity_per_year;
    tempInputs.totalMinutesOfActivityPerYearPostproject = newAdditionalInputs.post_project_conditions_walking.total_minutes_of_activity_per_year;
    tempInputs.totalMinutesOfActivityPerPersonPreproject = newAdditionalInputs.pre_project_conditions_walking.total_minutes_of_activity_per_pedestrian;
    tempInputs.totalMinutesOfActivityPerPersonPostproject = newAdditionalInputs.post_project_conditions_walking.total_minutes_of_activity_per_pedestrian;
    tempInputs.totalPeoplePerYearPostproject = newAdditionalInputs.post_project_conditions_walking.total_pedestrians_per_year;
    tempInputs.totalPeoplePerYearPreproject = newAdditionalInputs.pre_project_conditions_walking.total_pedestrians_per_year;
    tempInputs.totalTripsPerYearPostproject = newAdditionalInputs.post_project_conditions_walking.total_trips_per_day;
    tempInputs.totalTripsPerYearPreproject = newAdditionalInputs.pre_project_conditions_walking.total_trips_per_day;
    tempInputs.tripsPerDayPostproject = newAdditionalInputs.post_project_conditions_walking.trips_per_day;
    tempInputs.tripsPerDayPreproject = newAdditionalInputs.pre_project_conditions_walking.trips_per_day;
    tempInputs.tripsPerYearPerUser = newAdditionalInputs.pedestrian_travel_characteristics.trips_per_year_per_user;
    tempInputs.minimumTripDistance = newAdditionalInputs.pedestrian_travel_characteristics.minimum_trip_distance;
    tempInputs.totalModeShift = newAdditionalInputs.proportion_project_other_modes.total_mode_shift;
    tempInputs.newTrips = newAdditionalInputs.proportion_new_pedestrian_trips.new_walking_trips;
    tempInputs.carMotorcycleRideSharePersonsPVehicle =newAdditionalInputs.vehicle_load_factors.car_and_motorcycle_share;
    tempInputs.carMotorcycleSoloDriverPersonsPVehicle =newAdditionalInputs.vehicle_load_factors.car_and_motorcycle_solo;
    tempInputs.taxiOrMinibusPersonsPerVehicle = newAdditionalInputs.vehicle_load_factors.taxi_and_minibus;
    tempInputs.publicTransportPersonsPerVehicle = newAdditionalInputs.vehicle_load_factors.public_transport;
    tempInputs.projectTotalPercentage = newAdditionalInputs.proportion_project_origin_modes.total;
    tempInputs.coronaryHeartDiseaseMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[0].minutes_per_week;
    tempInputs.coronaryHeartDisease = newAdditionalInputs.morbidity_risk_reduction[0].risk_reduction_percentage;
    tempInputs.strokeMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[1].minutes_per_week;
    tempInputs.strokeRiskReduction = newAdditionalInputs.morbidity_risk_reduction[1].risk_reduction_percentage;
    tempInputs.dementiaMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[2].minutes_per_week;
    tempInputs.dementia = newAdditionalInputs.morbidity_risk_reduction[2].risk_reduction_percentage;
    tempInputs.typeIiDiabetesMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[3].minutes_per_week;
    tempInputs.typeIiDiabetes = newAdditionalInputs.morbidity_risk_reduction[3].risk_reduction_percentage;
    tempInputs.depressionMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[4].minutes_per_week;
    tempInputs.depression = newAdditionalInputs.morbidity_risk_reduction[4].risk_reduction_percentage;
    tempInputs.breastCancerMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[5].minutes_per_week;
    tempInputs.breastCancer = newAdditionalInputs.morbidity_risk_reduction[5].risk_reduction_percentage;
    tempInputs.colonCancerMinutesPWeek = newAdditionalInputs.morbidity_risk_reduction[6].minutes_per_week;
    tempInputs.colonCancer = newAdditionalInputs.morbidity_risk_reduction[6].risk_reduction_percentage;
    //tempInputs.cyclistPopulationCompositionBAgeCohort = handleCompositionObject();

    // TODO REVISAR
    tempInputs.numberOfCrimes = 0;

    tempInputs.cityName = cityDetails.originalCityName;
    tempInputs.cityId = cityDetails.cityId;

    setUserInputs(tempInputs)
  };

  const now = new Date();
  const creationDate = [    
    String(now.getDate()).padStart(2, "0"),
    String(now.getMonth() + 1).padStart(2, "0"),
    now.getFullYear()
  ].join(" ");

  const getProjectDisplayName = (name) =>
    typeof name === "string" && name.trim() !== ""
      ? name.trim()
      : "No name defined";

  const handleProjectNameChange = (event) => {
    setProjectName(event.target.value);
  };

  useEffect(() => {
    setSimulationResults((prev) => {
      if (!prev || Array.isArray(prev) || !prev.projectInfo) {
        return prev;
      }

      return {
        ...prev,
        projectName: getProjectDisplayName(projectName),
      };
    });
  }, [projectName]);
 
  const getData = async (userInputs) => {
    try {
      const dataTemp = await DataService.SimulateUserProject(userInputs);

        setSimulationResults({
          projectInfo: dataTemp?.data ?? [],
          actionSimulationId: dataTemp?.data?.simulationId || 0,
          creationDate: creationDate,
          projectNumber: 99999,
          projectName: getProjectDisplayName(projectName)
        });
      } catch (error) {
        console.error("Erro na API ao ler a Simulação:", error);
      } finally {
        setIsProcessing(false);
      }
  }

  useEffect(() => {
    // Espera o Dialog renderizar o Box antes de criar o mapa

    if (mapRef.current) {
      // Limpa mapa anterior
      if (mapInstance.current) {
        mapInstance.current.setTarget(null);
        mapInstance.current = null;
      }

      // Cria novo mapa
      mapInstance.current = new Map({
        target: mapRef.current,
        layers: [MapUtils.GetBaseLayer()],
        view: new View({ center: [0, 0], zoom: 2 }),
      });
    }

    if (localStorage.cities !== undefined) {
      setCities(
        MapUtils.sortCitiesByCountryThenName(JSON.parse(localStorage.cities))
      );
      LoadCities(mapInstance.current);
    } else {
      DataService.GetCities().then((e) => {
        var data = MapUtils.sortCitiesByCountryThenName(e);
        setCities(data);
        LoadCities(mapInstance.current);
      });
    }
    AddMapClick(mapInstance.current);
    // Hover tooltip for city dots and grid cells; attached once here (it used to be re-attached on every city change)
    MapUtils.LoadTooltipOverlayForNeighbourhood(mapInstance.current);
    setMap(mapInstance.current);
    actions.length === 0 && getAllActions();
  }, []);

  // debug: detect if gridFeatures contains items with missing neighborhoodGridId
  useEffect(() => {
    if (!gridFeatures || gridFeatures.length === 0) return;
    const missing = gridFeatures.filter(
      (g) => !g || !g.values_ || g.values_.neighborhoodGridId == null
    );
    if (missing.length > 0) {
      console.warn('Grid features with missing neighborhoodGridId found:', missing.length, missing.slice(0,3));
    }
  }, [gridFeatures]);

  const getAdditionInputs = async (regionName, countryName) => {
      const dataTemp = await DataService.getAdditionalInputs(regionName, countryName);
      let currency = dataTemp.data.currency_list.find(currency => currency.nation === 'United States of America')
      
      //setCurrencyList(dataTemp.data.currency_list)
      dataTemp.data = {...dataTemp.data, selectedCurrency: currency.id}
      //setSelectedCurrency(currency);
      setNewAdditionalInputs(dataTemp.data);
      //cleanFields();
      
      //getYLDTable(countryName, dataTemp.data)
           
      //setHasResult(false);
      //setIncludePreProject(true)      
  }
  const handleDeleteIndicator = (indicatorId) => {
    setListOfSimulations((prev) =>
      prev.filter((simulation) => simulation.indicatorId !== indicatorId)
    );
  };
  const handleSaveProject = () => {
    //console.log("cityDetails=", cityDetails)
    let tempInput = {... userInputs}
    tempInput.projectName = projectName;
    populateGridsIndicartor(tempInput); 

    tempInput.projectInfo.cityName = cityDetails.originalCityName;
    console.log("Temp Input before save = ", tempInput);

    saveProject(tempInput);
    setUserInputs(tempInput);
  }
  const populateGridsIndicartor = (tempInput) => {

    const simulationId = simulationResults.actionSimulationId;
    let indicatorGrids = [];
    
    tempInput.actionSimulationId = simulationId;
    tempInput.projectInfo = simulationResults.projectInfo;
    tempInput.projectInfo.selectedGrids = selectedGrids.map((grid) => ({
      gridId: grid.values_.neighborhoodGridId,
      name: grid.values_.name
    }));
    tempInput.projectInfo.selectedGridIds = tempInput.userSelectedGrids;
    // Save each action's own id and level, mirroring handleActionsPopulation (what was simulated).
    // levelValue stays a string: projectSelection.levelLabel calls .trim() on it.
    for (let i = 0; i < listOfSimulations.length; i += 1) {
      indicatorGrids.push({
        indicatorId: listOfSimulations[i].indicatorId,
        actionSimulationId: listOfSimulations[i].actionAreaId,
        levelValue: String(Utils.ImpactConverter(listOfSimulations[i]))
      })
    }
    tempInput.projectInfo.actions = indicatorGrids;
  }

  const saveProject = async(dataToSave) => {
     try {
      const dataTemp = await DataService.SaveUserProject(dataToSave || userInputs);
      
      setSnackbarValue({
        severity:'success',
        message:"You have successfully saved the project"
      });
    } catch(error) {
      setSnackbarValue({
        severity:'error',
        message:error.response.data.message
      });
    }
  }
  const handleSnackbarClose = () =>  setSnackbarValue({
    severity:"warning",
    message:""
  });
  
  useEffect(() => {
    if (!(SnackbarValue.message=="")) {
      setOpenSnackbar(true)
    } else {
      setOpenSnackbar(false)
    }
  },[SnackbarValue])

  return (
    <>
      {isProcessing && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            bgcolor: 'rgba(0,0,0,0.35)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
          <Typography sx={{ mt: 2, fontWeight: 'bold', color: '#fff' }}>
            Processing...
          </Typography>
        </Box>
      )}
      <Grid container spacing={4}>
        {/* LOCATION */}
        <Grid item xs={12} md={4}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            LOCATION
          </Typography>
          <Box sx={{ backgroundColor: "#eee", border: "1px solid #ccc" }}>
            <Box
              ref={mapRef}
              className="map-container-location"
              onMouseLeave={handleMouseLeave}
              sx={{
                width: "100%",
                height: "50vh",
                borderRadius: "4px",
                overflow: "hidden",
              }}>
              <Button
                id="btn-clear-all"
                variant="contained"
                className={selectedGrids.length === 0 ? "hide" : "show"}
                size="small"
                onClick={() => handleClearAll()}>
                Clear Selection
              </Button>

              <Button
                id="btn-select-all"
                variant="contained"
                className={selectedCity != "" ? "show" : "hide"}
                size="small"
                onClick={() => handleSelectAll()}>
                Select all
              </Button>

              <FormControl className="select-location">
                <Autocomplete
                  id="simple-city-select"
                  autoSelect
                  onChange={handleChange}
                  options={cities}
                  groupBy={(option) => option.countryName}
                  value={cityDetails}
                  getOptionLabel={(option) => option?.originalCityName || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.cityId === value.cityId
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Select a city" />
                  )}
                  clearOnEscape
                />
              </FormControl>

              <div id="popup" className="ol-popup">
                <div id="popup-content"></div>
              </div>
            </Box>
          </Box>
        </Grid>

        {/* DETAILS */}
        <Grid item xs={12} md={4}>
          {newAdditionalInputs && Object.keys(newAdditionalInputs).length === 0 && (<>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                textAlign: "center",
              }}>
              <img
                style={{ marginTop: "40px" }}
                src={noProjectImg}
                color="textSecondary"
                alt="No Projects were found"></img>
              <Typography
                style={{ marginTop: "32px", marginBottom: "32px" }}>
                Please choose one city from the map on the left.
              </Typography>
            </Box>
          </>)}
          {newAdditionalInputs && Object.keys(newAdditionalInputs).length > 0 && (<>
            <Typography variant="h5" sx={{ mb: 2 }}>
              DETAILS
            </Typography>
          
            <Button
              variant="outlined"
              fullWidth
              sx={{ mb: 2, borderColor: "#00aaff", color: "#00aaff" }}
              onClick={handleOpenDialog}
            >
              CHANGE PARAMETERS
            </Button>
            <ChangeParametersDialog
              open={openDialog}
              onClose={handleClose}
              onSave={handleSaveParameters}
              newAdditionalInputs={newAdditionalInputs}
              setNewAdditionalInputs={setNewAdditionalInputs}
              userInputs={userInputs}
              advanceErrors={advanceErrors} 
              setAdvanceErrors={setAdvanceErrors}
            />
            <TextField
              fullWidth
              label="Project name"
              sx={{ mb: 2 }}
              value={projectName}
              onChange={handleProjectNameChange}
              inputProps={{ maxLength: 150 }}
            />

            <TextField fullWidth select 
              sx={{ mb: 2 }} 
              value={indicatorId || ""} 
              onChange={(e) => handleAreaDropdown(e)}
              label="Planning action areas"
              SelectProps={{
                open: openSelect,
                onOpen: () => {
                  if (selectedGrids.length === 0) {
                    setSnackbarValue({
                      severity:'warning',
                      message:"Please choose first where the action will take place"
                    });
                    setOpenSelect(false);
                  } else {
                    // permitir abertura
                    setOpenSelect(true);
                  }
                },
                onClose: () => setOpenSelect(false)
              }}
            >
              {filterAreaDropdown.map((action, index) => (
                <MenuItem key={`indicator-${index}`}              
                  value={action.indicatorId} 
                  name={action.indicatorId}         
                  className={action.disabled ? "menu-item-disabled" : ""}
                  >
                  <Box>
                    {action.indicatorName}
                  </Box>
                  {action.disabled && (
                    <StyledTooltip title="Disabled for this planning area because it is already at the maximum score" arrow>
                      <span style={{ backgroundPosition: "right", width: 24, backgroundRepeat: "no-repeat"}} className="icon"></span>
                    </StyledTooltip>
                  )}

                </MenuItem> 
              ))}
            </TextField>

            {indicatorId !== "" && (
              <TextField select fullWidth sx={{ mb: 2 }}
                label="Actions"
                id="select-first-label"
                value={actionAreaId || ""}
                onChange={(e) => handleIndicatorDropdown(e.target.value)}
              >
                <MenuItem value="">Select actions</MenuItem>
                  {listOfAreaActions
                        .map((action, index) => (
                    <MenuItem key={`indicator-${index}`} value={action.actionSimulationId}
                      className={amenityLevelOf(action.actionSimulationId) >= AMENITY_MAX_LEVEL ? "menu-item-disabled" : ""}>
                      <Box>{action.actionSimulationName}</Box>
                      <StyledTooltip title={amenityLevelOf(action.actionSimulationId) >= AMENITY_MAX_LEVEL
                        ? "Disabled for this planning area because it is already at the maximum level for this amenity"
                        : action.actionSimulationDescription} arrow>
                          <span style={{ backgroundPosition: "right", width: 24, backgroundRepeat: "no-repeat"}} className="icon"></span>
                      </StyledTooltip>
                    </MenuItem>
                  ))}
              </TextField>
            )}
            { actionAreaId !=="" && listOfAreaActions.length > 0 && 
            (<>
              { //listOfImpacts[0]?.type === "Value" && 
              selectedAction?.impactTypeName === "Value" &&(
              <>
                <TextField
                  fullWidth
                  //label={listOfAreaActions[0]?.valueName}
                  label={selectedAction?.valueName ?? selectedAction?.actionSimulationName ?? "Value"}
                  value={actionValue}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setActionValue(value);
                    handleLevelDropdown(value);
                  }}
                  onKeyDown={(e) => {
                    // prevent scientific notation, decimals and signs
                    if (["e", "E", ".", "+", "-"].includes(e.key)) e.preventDefault();
                  }}
                  onPaste={(e) => {
                    const paste = (e.clipboardData || window.clipboardData).getData("text");
                    if (!/^\d*$/.test(paste)) {
                      e.preventDefault();
                      // insert digits-only version
                      const cleaned = paste.replace(/\D/g, "");
                      setActionValue(cleaned);
                      handleLevelDropdown(cleaned);
                    }
                  }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <Typography variant="caption" className="mb-3">
                    {//listOfAreaActions[0]?.valueUnitInstruction
                    selectedAction.valueUnitInstructionS}
                </Typography>
              </>)}
              {listOfImpacts[0]?.type === "List" && (
                <TextField select
                  fullWidth
                  sx={{ mb: 2 }}
                  label={listOfAreaActions[0]?.valueName}
                  id="select-first-label"
                  value={actionValue || ""}
                  onChange={(e) => {
                    handleLevelDropdown(e.target.value)
                    setActionValue(e.target.value);
                  }}
                >
                  {listOfImpacts.map((impact, index) => (
                    impact.name && (
                    <MenuItem key={`impact-${index}`} value={impact.impactValue}
                      disabled={isNoOpAmenityLevel(actionAreaId, impact.impactValue)}>
                      {impact.name} - {impact.impactDescription}
                      {isNoOpAmenityLevel(actionAreaId, impact.impactValue) && " (already met in this area)"}
                    </MenuItem>
                  )))}
                </TextField>
              )}
            </>)}
            <Button
              variant="contained"
              fullWidth
              onClick={handleAddSimulationList}
              sx={{ backgroundColor: "#00aaff", fontWeight: "bold", mt: 2 }}>
              ADD ACTION
            </Button>
            {listOfSimulations.length > 0 && listOfSimulations.map((simulation, index) => (
              <React.Fragment key={`simulation-${index}`}>
                <Box sx={{ mt: 1, p: 1, backgroundColor: "#f9f9f9" }}>
                  <Box sx={{ mb: 0, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography sx={{mb:0}}>
                      {simulation.actionName} 
                      {(simulation.impact && simulation.impactListType != "Binary") ? `- ${simulation.impact}` : ""}
                    </Typography>
                    <DeleteForeverIcon 
                      onClick={() => handleDeleteIndicator(simulation.indicatorId)}
                      sx={{ cursor: "pointer", color: "#d32f2f", "&:hover": { color: "#b71c1c" } }}
                    />
                  </Box>
                </Box>
              </React.Fragment>              
            ))}
            {listOfSimulations.length > 0 && (
              <Button
                variant="outlined"
                fullWidth
                onClick={handleSimulation}
                sx={{
                  mt: 3,
                  borderColor: "#00aaff",
                  color: "#00aaff",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                }}>
                SIMULATE RESULTS
              </Button>
            )}
          </>)}
        </Grid>

        {/* RESULTS */}
        <Grid item xs={12} md={4}>
          {simulationResults.length !== 0 && (<>
            
            <ResultsTable selectedProjects={[simulationResults]} singleProject={true}/>
          
            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 2, backgroundColor: "#00aaff", fontWeight: "bold" }}
              onClick={handleSaveProject} // Volta ao layout inicial
            >
              SAVE PROJECT
            </Button>
          </>)}

          <Button
            variant="outlined"
            fullWidth
            sx={{
              mt: simulationResults.length !== 0 ? 2 : 6,
              color: "#6c757d",
              borderColor: "#6c757d",
              "&:hover": {
                backgroundColor: "#f1f1f1",
              },
            }}
            onClick={() => setShowNewProject(false)} // Volta ao layout inicial
          >
            CANCEL PROJECT
          </Button>
        </Grid>
      </Grid>
      <Snackbar open={openSnackbar} autoHideDuration={3500} 
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          handleSnackbarClose()}}
        >
        <MuiAlert  severity={SnackbarValue.severity}>{SnackbarValue.message}</MuiAlert >
      </Snackbar>
    </>
  );
}